import {
  mdiHome,
  //mdiViewDashboard,
  mdiFileDocument,
  mdiFileCancel,
  mdiFileArrowUpDown,
  mdiShield,
  mdiFileDocumentEdit,
  mdiMedicalBag,
  mdiOfficeBuilding,
  mdiHandshake,
  mdiAccountCircle,
  mdiAccountGroup,
  mdiAccountCog,
  mdiHumanHandsup,
  mdiCogSync,
  mdiSitemap,
  mdiLayersTriple,
  mdiPuzzle,
  mdiFormatLineSpacing,
  mdiShieldAccount,
  mdiShieldAccountVariant,
  mdiAccountMultiple,
  mdiBankCircle,
  mdiHistory,
  mdiFileDocumentArrowRight,
  mdiBriefcaseUpload,
  mdiFileCog,
} from "@mdi/js";

const Menu = [
  {
    text: "Home",
    name: "home",
    icon: mdiHome,
    isMainDashboard: true,
  },
  { isProductCategory: false }, //hide menu all partnership old service on sidebar

  {
    text: "Credit Life",
    name: "credit-life",
    icon: mdiShieldAccount,
    group: "credit-life",
    items: [
      {
        text: "Quote List",
        name: "quote",
        icon: mdiFileDocumentEdit,
      },
      {
        text: "Waiting for Approval",
        name: "waiting-for-approval",
        icon: mdiFileDocumentArrowRight,
      },
      {
        text: "Task History",
        name: "task-history",
        icon: mdiHistory,
      },
     
      {
        text: "Policy List",
        name: "policy",
        icon: mdiFileDocument,
      },
      {
        text: "Claim List",
        name: "claim",
        icon: mdiShield,
      },
    ],
  },
  {
    text: "Product Management",
    name: "product-management",
    icon: mdiFileCog,
  },
  // {
  //   text: "Insurance Management",
  //   name: "insurance",
  //   icon: mdiMedicalBag,
  //   group: "insurance",
  //   items: [
  //     {
  //       text: "Insurance Category List",
  //       name: "insurance-categories",
  //       icon: mdiShieldAccountVariant,
  //     },
  //     {
  //       text: "Insurer List",
  //       name: "insurer",
  //       icon: mdiShieldAccount,
  //     },
  //   ],
  // },
  // {
  //   text: "Partner Management",
  //   name: "partner",
  //   icon: mdiHandshake,
  // },
  // {
  //   text: "Organisation Management",
  //   name: "organisation",
  //   icon: mdiOfficeBuilding,
  // },
  {
    text: "Bank Management",
    name: "bank-management",
    icon: mdiBankCircle,
  },
  {
    text: "Broker Management",
    name: "broker-management",
    icon: mdiAccountMultiple,
  },
  {
    text: "Agent Management",
    name: "agent-management",
    icon: mdiAccountGroup,
  },
  {
    text: "Access Management",
    name: "access-management",
    icon: mdiAccountCircle,
    group: "access-management",
    items: [
      {
        text: "User List",
        name: "user",
        icon: mdiAccountGroup,
      },
      {
        text: "Role List",
        name: "role",
        icon: mdiAccountCog,
      },
      {
        text: "Privilege List",
        name: "privilege",
        icon: mdiHumanHandsup,
      },
    ],
  },
  // {
  //   text: "Hierarchy Management",
  //   name: "hierarchy-management",
  //   icon: mdiSitemap,
  //   group: "hierarchy-management",
  //   items: [
  //     {
  //       text: "Level List",
  //       name: "level",
  //       icon: mdiLayersTriple,
  //     },
  //     {
  //       text: "Section List",
  //       name: "section",
  //       icon: mdiPuzzle,
  //     },
  //   ],
  // },
  {
    text: "Internal Tools",
    name: "internal-tools",
    icon: mdiCogSync,
    group: "internal-tools",
    items: [
      {
        text: "Adhoc Request Form",
        name: "adhoc-request-form",
        icon: mdiBriefcaseUpload,
      },
    ],
  },
  {
    text: "Customise Navigation",
    action: "customiseNavigation",
    icon: mdiFormatLineSpacing,
  },
];

export default Menu;
